import { Injectable } from '@angular/core';
import {
    DatiqGraphSeriesType,
    IDatiqGraph,
    IDatiqGraphAxis,
    IDatiqGraphSeries,
} from '@dat/datiq-components-pkg/graph';
import { datGrey } from '@dat/datiq-components-pkg/utils';
import { DATIQ_DEFAULT_ID } from '@dat/datiq-core/models';
import {
    emptyDatiqGraphCardChartGraph,
    emptyDatiqGraphCardChartGraphAxisX,
    IDatiqGraphCardChart
} from '../models';

@Injectable({
    providedIn: 'root',
})
export class DatiqGraphCardChartMapperService {
    constructor() {}

    mapGraph(settings: IDatiqGraphCardChart): IDatiqGraph {
        const series: IDatiqGraphSeries[] = this.mapGraphSeries(settings);
        const xAxes = this.mapGraphXAxes(settings);
        const yAxes = this.mapGraphYAxes(settings);
        return {
            ...emptyDatiqGraphCardChartGraph,
            xAxes,
            yAxes,
            series,
            hasData: true,
        };
    }
    mapGraphSeries(settings: IDatiqGraphCardChart): IDatiqGraphSeries[] {
        const averageSeries: IDatiqGraphSeries =
            this.mapGraphSeriesAverage(settings);
        return [averageSeries];
    }
    mapGraphSeriesAverage(settings: IDatiqGraphCardChart): IDatiqGraphSeries {
        return {
            id: DATIQ_DEFAULT_ID('datiq-graph-card-chart-graph-series'),
            type: DatiqGraphSeriesType.Line,
            color: datGrey[500],
            data: settings?.data.actual.map((val, index) => ({
                x: index,
                y: val,
            })),
        };
    }
    mapGraphXAxes(settings: IDatiqGraphCardChart): IDatiqGraphAxis[] {
        const xAxes = {
            ...emptyDatiqGraphCardChartGraphAxisX,
            strictMinMax: settings.useStrictMinMax
        };
        return [xAxes];
    }
    mapGraphYAxes(settings: IDatiqGraphCardChart): IDatiqGraphAxis[] {
        const yAxes = {
            ...emptyDatiqGraphCardChartGraphAxisX,
        };

        if (settings.useStrictMinMax && settings?.data?.actual) {
            yAxes.min = Math.min(...settings.data.actual);
            yAxes.max = Math.max(...settings.data.actual);
        }
   
        return [yAxes];
    }
}
